var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex justify-content-between w-100" }, [
    _c(
      "div",
      { staticClass: "d-flex gap-10 h-35" },
      [
        _c("router-link", {
          class: "flex-grow-1",
          attrs: { to: { name: "Welcome", params: { uuid: _vm.id } } },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({
                href,
                route,
                navigate,
                isActive,
                isExactActive,
              }) {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "download-btn px-3 h-35",
                      on: { click: navigate },
                    },
                    [
                      _c("i", { staticClass: "fa lh-inherit fa-arrow-left" }),
                      _vm._v(
                        " " + _vm._s(_vm._f("trans")("Back")) + "\n            "
                      ),
                    ]
                  ),
                ]
              },
            },
          ]),
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "download-btn h-100 gap-10px h-35 px-3",
            attrs: { title: _vm._f("trans")("Download") },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.download()
              },
            },
          },
          [
            _c("i", { staticClass: "far fa-download lh-inherit" }),
            _vm._v(" " + _vm._s(_vm._f("trans")("Download")) + "\n        "),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.isCopyClicked
      ? _c(
          "div",
          { staticClass: "copied-text-success gap-10 font-weight-bold" },
          [
            _c("i", { staticClass: "far fa-check-circle font-size-110" }),
            _vm._v(" " + _vm._s(_vm._f("trans")("Copied!")) + "\n    "),
          ]
        )
      : _c(
          "div",
          {
            staticClass:
              "file-action-btn gap-10 font-weight-bold copy-text-to-clipboard-btn",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.copyText.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "20",
                  height: "21",
                  viewBox: "0 0 20 21",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M7.8 15.3C7.36 15.3 6.98347 15.1435 6.6704 14.8304C6.35733 14.5173 6.20053 14.1405 6.2 13.7V4.1C6.2 3.66 6.3568 3.28347 6.6704 2.9704C6.984 2.65733 7.36053 2.50053 7.8 2.5H15C15.44 2.5 15.8168 2.6568 16.1304 2.9704C16.444 3.284 16.6005 3.66053 16.6 4.1V13.7C16.6 14.14 16.4435 14.5168 16.1304 14.8304C15.8173 15.144 15.4405 15.3005 15 15.3H7.8ZM7.8 13.7H15V4.1H7.8V13.7ZM4.6 18.5C4.16 18.5 3.78347 18.3435 3.4704 18.0304C3.15733 17.7173 3.00053 17.3405 3 16.9V6.5C3 6.27333 3.0768 6.08347 3.2304 5.9304C3.384 5.77733 3.57387 5.70053 3.8 5.7C4.02667 5.7 4.2168 5.7768 4.3704 5.9304C4.524 6.084 4.60053 6.27387 4.6 6.5V16.9H12.6C12.8267 16.9 13.0168 16.9768 13.1704 17.1304C13.324 17.284 13.4005 17.4739 13.4 17.7C13.4 17.9267 13.3232 18.1168 13.1696 18.2704C13.016 18.424 12.8261 18.5005 12.6 18.5H4.6Z",
                    fill: "#2E2E2E",
                  },
                }),
              ]
            ),
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("trans")("Copy to Clipboard")) +
                "\n    "
            ),
          ]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }